import PlaceInner from './PlaceInner.jsx';

export default PlaceInner;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/PlaceInner/index.js